import React from 'react';
import './Footer2.css';

const Footer2 = () => {
  return (
    <div className="bottom-footer">
      <div className="bottom-links">
        <span>Privacy Policy</span>
        <span>|</span>
        <span>Terms and Conditions</span>
        <span>|</span>
        <span>Cookies</span>
      </div>
      <div className="copyright">
        ©2024 adidas India Marketing Pvt. Ltd
      </div>
    </div>
  );
};

export default Footer2;
